var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTaiLieu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 28.5714C0.666504 12.7919 13.4584 0 29.2379 0H72.0951C87.8746 0 100.667 12.7919 100.667 28.5714V71.4286C100.667 87.2081 87.8746 100 72.0951 100H29.2379C13.4584 100 0.666504 87.2081 0.666504 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_851)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7734 36.6072V63.3929C74.7734 71.4286 70.7555 76.7858 61.3805 76.7858H39.9519C30.5769 76.7858 26.5591 71.4286 26.5591 63.3929V36.6072C26.5591 28.5715 30.5769 23.2144 39.9519 23.2144H61.3805C70.7555 23.2144 74.7734 28.5715 74.7734 36.6072Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3628 29.9106V35.2678C57.3628 38.2142 59.7735 40.6249 62.7199 40.6249H68.0771",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9521 52.6787H50.6664",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9521 63.3928H61.3807",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_851",
    x1: 50.6665,
    y1: 0,
    x2: 50.6665,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8573F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D4ADB"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTaiLieu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/TaiLieu.4488c2e7.svg";
export { ForwardRef as ReactComponent };